import type { FilterFieldDef, FilterSurface } from './types'
import { Input } from '@/components/ui/input'
import { formatDateVN } from '@/lib/format'

interface DateFilterOptions {
    label: () => string
}

const controlClass = (surface: FilterSurface) => {
    if (surface === 'sheet') return 'h-11 w-full'
    // Ô ngoài render một lần cho cả hai bề mặt → phải responsive (R8).
    if (surface === 'outside') return 'h-11 w-full md:h-9'
    return 'h-9 w-full'
}

/** Chỉ nhận đúng dạng `yyyy-mm-dd`; mọi thứ khác coi như không lọc. */
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/

/**
 * Bộ lọc một mốc ngày. Nhãn là BẮT BUỘC: hai ô `dd/mm/yyyy` cạnh nhau mà
 * không nhãn thì không ai biết đâu là "Từ ngày" (R7).
 */
export function dateFilter({
    label,
}: DateFilterOptions): FilterFieldDef<string> {
    return {
        defaultValue: '',
        label,
        parse: (raw) =>
            typeof raw === 'string' && ISO_DATE.test(raw) ? raw : undefined,
        // URL giữ `yyyy-mm-dd` (sắp xếp được, khớp API), nhưng chip là chỗ
        // người dùng đọc nên hiện `d/M/yyyy` như mọi ngày tháng khác trong app.
        chipLabel: (value) => `${label()}: ${formatDateVN(value)}`,
        render: ({ id, value, onChange, surface }) => (
            <Input
                id={id}
                type="date"
                className={controlClass(surface)}
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
        ),
    }
}
